/**
 * Бейдж значення списку з тоном з метаданих (LST-07): колір лише підсилює текст (WCAG 1.4.1).
 * Тони — з реєстру платформи (`OPTION_TONES` у `@clientline/contracts`).
 */
export type BadgeTone = 'neutral' | 'ok' | 'warn' | 'danger' | 'accent';

const TONE_CLASS: Record<BadgeTone, string> = {
  neutral: 'badge',
  ok: 'badge badge--ok',
  warn: 'badge badge--warn',
  danger: 'badge badge--danger',
  accent: 'badge badge--accent',
};

export function OptionBadge({ label, tone }: { label: string; tone?: BadgeTone | undefined }) {
  return <span className={TONE_CLASS[tone ?? 'neutral'] ?? 'badge'}>{label}</span>;
}
